import * as React from 'react';
import { compose } from 'redux';

import { AuthenticationHelpButton } from '../../../NavbarHelpButton';
import Navbar from '../../../Navbar';

import { useTranslation, config } from '@shopee-user/platform';
// HOCs and Types
import { LoginByOtpOneCredentialOptionalRequireAuthKeyProps } from '@shopee-user/business-customization-types';
import { WithTrackingProps } from '@shopee-user/tracking';
import {
  withUserWebView,
  WithUserWebViewProps,
} from '@shopee-user/with-web-view';
import { useLoginByOtpOneCredentialFlowEvent } from '@tob/pages/login-by-otp-one-credential-optional/flow-event';

function _Header({
  webViewNavigateBack,
  ...props
}: WithTrackingProps &
  WithUserWebViewProps &
  LoginByOtpOneCredentialOptionalRequireAuthKeyProps) {
  const I18n = useTranslation();
  const { trackEvent } = useLoginByOtpOneCredentialFlowEvent();
  const {
    state: { shouldHideBack },
  } = props;

  return (
    <>
      <Navbar
        title={I18n.t('label_auth_otp_log_in', {
          context: config.BUSINESS_TARGET,
        })}
        onClickBack={() => {
          trackEvent('onLoginBackClick');
          webViewNavigateBack();
        }}
        rightContent={
          <AuthenticationHelpButton
            text={I18n.t('label_auth_help')}
            onClick={() => trackEvent('onLoginHelpClick')}
          />
        }
        shouldHideBack={shouldHideBack}
      />
    </>
  );
}

export const Header = compose<React.ComponentType>(withUserWebView({}))(
  _Header
);
